import { render } from "./AnnualInfocou.vue?vue&type=template&id=c4cf490a"
import script from "./AnnualInfocou.vue?vue&type=script&lang=js"
export * from "./AnnualInfocou.vue?vue&type=script&lang=js"

import "./AnnualInfocou.vue?vue&type=style&index=0&id=c4cf490a&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__